<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <el-tabs
      v-model="activeTab"
      tab-position="left"
      @tab-click="clickTabs(active_config_index)"
    >
      <el-tab-pane label="微信开放平台配置" name="store">
        <el-tabs type="border-card">
          <el-tab-pane label="微信开放平台配置">
            <el-form label-width="180px">
              <el-form-item label="开放平台APPID">
                <el-input size="small" type="text" v-model="appId"></el-input>
              </el-form-item>
              <el-form-item label="开放平台AppSecret">
                <el-input
                  size="small"
                  type="text"
                  v-model="appSecret"
                ></el-input>
              </el-form-item>
              <el-form-item label="消息校验Token">
                <el-input size="small" type="text" v-model="token"></el-input>
              </el-form-item>
              <el-form-item label="消息加解密Key">
                <el-input
                  size="small"
                  type="text"
                  v-model="encodIngaesKey"
                ></el-input>
              </el-form-item>
              <el-form-item label="注意事项">
                <el-alert
                  title="1. 确认保存完毕后,请在十分钟左右后开始检测问题"
                  type="warning"
                  show-icon
                  :closable="false"
                ></el-alert>
                <el-alert
                  title="2. 网站请不要强制开起https，避免授权后页面不跳转"
                  type="warning"
                  show-icon
                  :closable="false"
                ></el-alert>
              </el-form-item>
            </el-form>
            <div class="center">
              <el-button size="small" @click="checkWxConfig"
              >检查问题
              </el-button
              >
              <el-button type="primary" size="small" @click="saveWxConfig"
              >确认保存
              </el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-tabs type="border-card" style="margin: 20px 0">
          <el-tab-pane label="微信开放平台接入配置项">
            <el-form label-width="180px">
              <el-form-item label="登录授权的发起页域名">
                <div class="long">
                  <el-input
                    readonly
                    v-model="this.appConfig.urlName"
                    size="small"
                    type="text"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item label="授权事件接受URL">
                <div class="long">
                  <el-input
                    readonly
                    v-model="this.appConfig.authName"
                    size="small"
                    type="text"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item label="公众号消息与事件接受URL">
                <div class="long">
                  <el-input
                    readonly
                    v-model="this.appConfig.notifyUrl"
                    size="small"
                    type="text"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item label="网页开发域名">
                <div class="long">
                  <el-input
                    readonly
                    v-model="this.appConfig.urlName"
                    size="small"
                    type="text"
                  ></el-input>
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane name="xiaochengxu" label="小程序配置">
        <el-tabs type="border-card">
          <el-tab-pane label="小程序配置">
            <el-form label-width="180px">
              <el-form-item label="服务器域名">
                <el-input size="small" type="text" v-model="server"></el-input>
              </el-form-item>
              <el-form-item label="小程序业务域名">
                <el-input
                  size="small"
                  type="text"
                  v-model="business"
                ></el-input>
              </el-form-item>
              <el-form-item label="小程序版本号">
                <el-input size="small" type="text" v-model="version"></el-input>
              </el-form-item>
              <el-form-item label="小程序简介">
                <el-input
                  type="textarea"
                  v-model="information"
                  style="height: 120px"
                ></el-input>
              </el-form-item>
              <el-form-item label="小程序标签">
                <el-input type="textarea" v-model="tag"></el-input>
              </el-form-item>
            </el-form>
            <div class="center">
              <el-button size="small" @click="urgentAudit"
              >商城小程序加急审核
              </el-button
              >
              <el-button size="small" v-loading.fullscreen.lock="fullscreenLoading" @click="chooseProgram"
              >选择商城小程序模板
              </el-button
              >
              <el-button type="primary" size="small" @click="saveXcxConfig"
              >确认保存
              </el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>

    <!-- 商城小程序模板 -->
    <el-dialog
      title="选择商城小程序模板"
      :visible.sync="appletTemplateVisible"
      width="80%"
      custom-class="appletTemplateBox"
      v-loading='loading'
    >
      <span>
        <template>
          <el-tabs
            v-model="activeName"
            @tab-click="draftOrTemplatesTab"
            style="background-color: #ffffff; padding: 10px 10px"
          >
            <el-tab-pane label="草稿箱" name="first">
              <div class="draftTip">
                <div style="width: 10px; background-color: green"></div>
                <div class="tipText">每个小程序只保留最新一次的上传记录</div>
              </div>
              <div class="draftTable">
                <el-table :data="draftTableData" border :header-row-class-name='headerClass' style="width: 100%">
                  <el-table-column prop="user_version" label="版本号">
                  </el-table-column>
                  <el-table-column prop="user_desc" label="描述">
                  </el-table-column>
                  <el-table-column prop="source_miniprogram" label="来源小程序">
                  </el-table-column>
                  <el-table-column prop="developer" label="最近上传开发者">
                  </el-table-column>
                  <el-table-column prop="create_time" label="最近提交时间">
                    <template slot-scope="scope">
                        {{scope.row.create_time|timeToDate()}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="draftAdd(scope.row)"
                        >添加</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="模板库" name="second">
              <div class="draftTip">
                <div style="width: 10px; background-color: green"></div>

                <div class="tipText">最多可添加50个，还可以添加{{50-tempalteTableData.length}}个</div>
              </div>
              <div class="draftTable">
                <el-table :data="tempalteTableData" border :header-row-class-name='headerClass' style="width: 100%">
                  <el-table-column prop="user_version" label="版本号">
                  </el-table-column>
                  <el-table-column prop="user_desc" label="描述">
                  </el-table-column>
                  <el-table-column prop="template_id" label="模板id">
                  </el-table-column>
                  <el-table-column prop="source_miniprogram" label="来源小程序">
                  </el-table-column>
                  <el-table-column prop="developer" label="最近上传开发者">
                  </el-table-column>
                  <el-table-column prop="create_time" label="最近提交时间">
                    <template slot-scope="scope">
                        {{scope.row.create_time|timeToDate()}}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                       <div class="cellOperator">
                                <div>
                                    <el-button
                                    v-if="scope.row.selectedState"
                                    size="mini"
                                    type="success"
                                    style="background-color:green"
                                    >当前选择</el-button>
                                    <el-button
                                    v-else
                                    size="mini"
                                    type="success"
                                    style="background-color:green"
                                    @click="toSelecte(scope.row,scope.$index)"
                                    >选择</el-button>
                                </div>
                                <el-button
                                size="mini"
                                type="warning"
                                style="background-color:#ebb563"
                                @click="omitTemplate(scope.row)"
                                >删除</el-button>
                       </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
      </span>
    </el-dialog>

    <!-- 商城小程序加急审核 -->
    <el-dialog
      title="商城小程序加急审核"
      :visible.sync="appletUrgentAuditVisible"
      width="80%"
      custom-class="appletUrgentAuditBox"
      v-loading='loading'
    >
      <span>
        <template>
          <div class="queryUrgent">
            <div class="urgentPanel">
              <div class="urgentPanelTitle">quota剩余值</div>
              <div class="urgentPanelValue" style="border-top: 1px solid rgb(238, 238, 255);color:5E57E3">{{queryUrgentInfo.rest}}</div>
            </div>
            <div class="urgentPanel">
              <div class="urgentPanelTitle">当月分配quota</div>
              <div class="urgentPanelValue" style="border-top: 1px solid rgb(238, 238, 255);color:5E57E3">{{queryUrgentInfo.limit}}</div>
            </div>
            <div class="urgentPanel">
              <div class="urgentPanelTitle">剩余加急次数</div>
              <div class="urgentPanelValue" style="border-top: 1px solid rgb(238, 238, 255);color:5E57E3">{{queryUrgentInfo.speedup_rest}}</div>
            </div>
            <div class="urgentPanel">
              <div class="urgentPanelTitle">当月分配加急次数</div>
              <div class="urgentPanelValue" style="border-top: 1px solid rgb(238, 238, 255);color:5E57E3">{{queryUrgentInfo.speedup_limit}}</div>
            </div>
          </div>
          <div class="queryMerchants">
            <label>选择商户</label>
            <el-select v-model="merchantValue" filterable placeholder="输入商户名称搜索">
              <el-option
                v-for="item in merchantsOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <mybutton @click.native="searchMerchants()" label="搜索"></mybutton>
          </div>
          <div class="merchantsTable">
            <SimpleTable :tableDataP="merchantsTableData" :tableDataTitle="merchantsTableDataTitle" :border='"border"'>
              <el-table-column slot="serialNumber" label="序号">
                <template slot-scope="scope">
                    {{scope.$index+1}}
                </template>
              </el-table-column>
              <el-table-column slot="merchantStatus" label="状态">
                <template slot-scope="scope">
                    {{scope.row.status|auditStatus()}}
                </template>
              </el-table-column>
              <el-table-column slot="operator" label="操作">
                <template slot-scope="scope">
                    <div class="cellOperator">
                            <div>
                                <el-button
                                v-if="scope.row.selectedState"
                                size="mini"
                                type="success"
                                style="background-color:green"
                                >当前选择</el-button>
                                <el-button
                                v-else
                                size="mini"
                                type="success"
                                style="background-color:green"
                                @click="toSelecte(scope.row,scope.$index)"
                                >选择</el-button>
                            </div>
                            <el-button
                            size="mini"
                            type="warning"
                            style="background-color:#ebb563"
                            @click="omitTemplate(scope.row)"
                            >删除</el-button>
                    </div>
                </template>
              </el-table-column>
            </SimpleTable>
          </div>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import api from '@/config/api';
  import SimpleTable from '@/components/template/simpleTable'

  export default {
  data() {
    let headerClass = function ({row, rowIndex}) {
      return 'tableHeader'
    }
    return {
      headerClass,
      fullscreenLoading:false,
      loading:false,
      queryUrgentInfo:{},//剩余加急次数等查询信息
      merchantsOption: [],
      merchantValue: '',//当前下拉框选中的商户ID
      merchantsTableDataTitle:[
        {
	       slot:'serialNumber',
	       label:'序号',
        },{
	       prop:'merchantName',
	       label:'商户名称',
        },{
	       prop:'merchantAccount',
	       label:'商户账号',
        },{
	       prop:'appletName',
	       label:'小程序名称',
        },{
	       prop:'auditVersion',
	       label:'提交审核版本',
        },{
	       prop:'versionDescription',
	       label:'版本描述',
        },{
	       prop:'commitTime',
	       label:'提交时间',
        },{
	       prop:'isUrgent',
          label: '是否已加急',
        },{
	       slot:'merchantStatus',
          label: '状态',
        },{
	       slot:'operator',
          label: '操作',
        }
      ],
      merchantsTableData: [
        {
          merchantName:'千里香小馄饨',
          merchantAccount:'193499',
          appletName:'店播云商城',
          auditVersion: '1.0.0',
          versionDescription: '加急的商户小程序',
          commitTime: '2020-08-18 15:16:39',
          isUrgent: 'true',
          status:1
        }
      ],
      tempalteTableData: [
        {
          versionId: "1.0.0",
          description: "娱乐型小程序",
          templateId: 'a09',
          fromApplet: "店播云商城",
          uploaderAuthor: "踏月之人",
          commitTime: '2020-08-18 15:16:39',
          selectedState: true
        }
      ],
      draftTableData: [
        {
          versionId: "1.0.0",
          description: "娱乐型小程序",
          fromApplet: "店播云商城",
          uploaderAuthor: "踏月之人",
          commitTime: '2020-08-18 15:16:39'
        }
      ],
      activeName: "first",
      appletUrgentAuditVisible: false,
      appletTemplateVisible: false,
      appConfig: {
        urlName: "",
        authName: "",
        notifyUrl: "",
      },
      appId: "",
      appSecret: "",
      token: "",
      encodIngaesKey: "",
      version: "",
      server: "",
      business: "",
      information: "",
      tag: "",
      openAppid: "",
      openAppsecret: "",
      mestoken: "",
      mesKey: "",
      title: "",
      activeTab: "store",
      active_config_index: "1", //当前点击的标签
    };
  },
  components:{
    SimpleTable
  },
  methods: {
    clickTabs: function (index) {
      localStorage.active_config_index = index;
    },
    copyUrl() {
    },
    //搜索某个商户剩余加急次数等信息
    searchMerchants(){
      console.log('搜索了',this.merchantValue)
      this.fullscreenLoading=true;
      let url=api.system.queryAuditCount+`?id=${this.merchantValue}`;
      this.$axios.fetchPost(url).then((res)=>{
        this.fullscreenLoading=false;
        if(res.code===200){
          this.$set(this.queryUrgentInfo,'rest',res.data.rest);
          this.$set(this.queryUrgentInfo,'limit',res.data.limit);
          this.$set(this.queryUrgentInfo,'speedup_limit',res.data.speedup_limit);
          this.$set(this.queryUrgentInfo,'speedup_rest',res.data.speedup_rest);
        }else{
          this.$message.error(res.errorMsg);

          this.$set(this.queryUrgentInfo,'rest','暂无信息');
          this.$set(this.queryUrgentInfo,'limit','暂无信息');
          this.$set(this.queryUrgentInfo,'speedup_limit','暂无信息');
          this.$set(this.queryUrgentInfo,'speedup_rest','暂无信息');
        }
      })

      //加急小程序具体数据拉取
      url=api.system.merChantInfo+`?id=${this.merchantValue}`;
      this.merchantsTableData=[];
      this.$axios.fetchPost(url).then((res)=>{
        console.log('加急表格数据',res)

        if(res.code===200){
          for(let i=0;i<res.data.length;i++){
            let objectAdaptor={
              merchantName:res.data[i].merchantName,
              merchantAccount:res.data[i].merchantId,
              appletName:res.data[i].programName,
              auditVersion: res.data[i].version,
              versionDescription: res.data[i].versionInfo,
              commitTime: res.data[i].createDttm,
              isUrgent: res.data[i].urgentAudit?'是':'否',
              status: res.data[i].status
            }
            this.merchantsTableData.push(objectAdaptor);
          }
        }else{
          this.$message.error('具体商户数据加载失败！');
        }
      })
    },
    //删除模板
    async omitTemplate(row){
      let url=api.system.templateOmit+`?id=${row.template_id}`;
      this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        this.fullscreenLoading=true;
        await this.$axios.fetchPost(url).then((res)=>{
          this.fullscreenLoading=false
          if(res.code===200){
            this.$notify({
              type: "success",
              title: '删除操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
          }else{
            this.$notify({
              type: "error",
              title: '删除操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error('删除异常！');
          }
        })

        this.chooseProgram()
      }).catch(() => {
        this.$notify({
          type: "info",
          title: '删除操作',
          message: '取消',
          showClose: false,
        });
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    //选择模板
    toSelecte(row,index){
      this.fullscreenLoading=true;
      this.$axios.fetchPost(`/api/system/sysAppConfig/update/template?id=${row.template_id}`).then((res)=>{
        this.fullscreenLoading = false;
        if(res.code===200){
          for(let i=0;i<this.tempalteTableData.length;i++){
            this.tempalteTableData[i].selectedState=false;
            this.$set(this.tempalteTableData,index,this.tempalteTableData[i]);
          }
          row.selectedState=true;

          this.$set(this.tempalteTableData,index,row)
          this.$notify({
            type: "success",
            title: '选择模板操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({
          //   message:'选择成功',
          //   type:'success'
          // })
        }else{
          this.$notify({
            type: "error",
            title: '选择模板操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error('选择异常');
        }
      })
    },
    //检查问题
    checkWxConfig() {
    },
    //确认保存
    saveWxConfig() {
      let data = {
        id: this.appConfig.id,
        appId: this.appId,
        appSecret: this.appSecret,
        token: this.token,
        encodIngaesKey: this.encodIngaesKey,
      };
      this.$axios.fetchPost("/api/system/sysAppConfig", data).then((data) => {
        console.log(data);
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '保存操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: "保存成功！", type: "success"});
        }
      });
    },
    //商城小程序加急审核
    urgentAudit() {
      this.appletUrgentAuditVisible=true;
      this.fullscreenLoading=true;
      //对可选商户下拉框数据的拉取
      let url=api.system.submitMerchant+'/list';
      this.merchantsOption=[{
          value: '',
          label: '请选择'
        }];
      this.$axios.fetchPost(url).then((res=>{
        console.log('商户下拉框数据',res)
        this.fullscreenLoading=false;
        if(res.code===200){
          for(let i=0;i<res.data.length;i++){
            let objectAdaptor={
              value:res.data[i].id,
              label:res.data[i].name
            }
            this.merchantsOption.push(objectAdaptor);
          }
        }else{
          this.$message.error('商户下拉框数据失败！');
        }
      }))
      //加急小程序表格数据拉取
      // url=api.system.urgentAppletList;
      // this.merchantsTableData=[];
      // this.$axios.fetchPost(url).then((res)=>{
      //   console.log('加急表格数据',res)

      //   if(res.code===200){
      //     for(let i=0;i<res.data.length;i++){
      //       let objectAdaptor={
      //         merchantName:res.data[i].merchantName,
      //         merchantAccount:res.data[i].merchantId,
      //         appletName:res.data[i].programName,
      //         auditVersion: res.data[i].version,
      //         versionDescription: res.data[i].versionInfo,
      //         commitTime: res.data[i].createDttm,
      //         isUrgent: res.data[i].urgentAudit?'是':'否',
      //         status:res.data[i].status
      //       }
      //       this.merchantsTableData.push(objectAdaptor);
      //     }
      //   }else{
      //     this.$message.error('加急小程序列表数据加载失败！');
      //   }
      // })
    },
    //选择商城小程序模板
    chooseProgram() {
      this.fullscreenLoading=true;
      let url=api.system.selectedAppletTem;
      this.$axios.fetchPost(url).then((res)=>{
        console.log('返回============',res)
        if(res.code===200){
            this.draftTableData=res.data.draftsList;
            this.tempalteTableData=[...res.data.templateList];
            this.auditionTemplate(res.data.version,res.data.templateList);

            this.fullscreenLoading=false;
            this.appletTemplateVisible = true;
        }else{
            this.fullscreenLoading=false;
            console.log('小程序模板数据拉取错误')
        }
      })
    },
    //对当前使用的模板在大海中反选
    auditionTemplate(version,tempalteTableData=[]){
      // 全部为未选择状态
      for(let i=0;i<tempalteTableData.length;i++){
        tempalteTableData[i].selectedState=false;
      }
      if(!version)
        return
      let currentTemplate=tempalteTableData.find((item,index)=>{
        return item.template_id===version
      })
      currentTemplate&&(currentTemplate.selectedState=true);

    },
    draftOrTemplatesTab() {
    },
    //确认保存
    saveXcxConfig() {
      let data = {
        id: this.appConfig.id,
        server: this.server,
        business: this.business,
        information: this.information,
        version: this.version,
      };
      this.$axios.fetchPost("/api/system/sysAppConfig", data).then((data) => {
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '保存操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: "保存成功！", type: "success"});
        }
      });
    },
    //草稿箱中的添加动作
    async draftAdd(row){
      this.fullscreenLoading=true;
      let url=api.system.draftAddTemplate+`?id=${row.draft_id}`;
      await this.$axios.fetchPost(url).then((res)=>{
        this.fullscreenLoading=false;
        if(res.code===200){
          this.$notify({
            type: "success",
            title: '添加操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({
          //   message: '添加成功！',
          //   type: 'success'
          // });
        }
      })
      this.chooseProgram();
    }
  },
  mounted() {
    this.title = document.title;
  },
  created() {
    this.$axios
      .fetchPost("/api/system/sysAppConfig/query")
      .then((data) => {
        console.log(data);
        if (data.code === 200) {
          let appCofing = data.data.app_config;
          this.appId = appCofing.appId;
          this.appSecret = appCofing.appSecret;
          this.token = appCofing.token;
          this.encodIngaesKey = appCofing.encodIngaesKey;
          this.version = appCofing.version;
          this.server = appCofing.server;
          this.business = appCofing.business;
          this.information = appCofing.information;
          this.tag = appCofing.tag;
          Object.assign(this.appConfig, appCofing);
        }
      })
      .catch((err) => {
        this.$message({message: "获取信息失败！", type: "info"});
      });
  },
};
</script>

<style scoped>

.long {
  display: flex;
}

.long .el-input {
  flex: 1;
}

.content-list-btn {
  margin-left: 10px;
}

.el-button {
  line-height: 0;
}

.center {
  text-align: center;
  margin-top: 15px;
}

>>> .el-textarea__inner {
  height: 100px;
  margin-bottom: 10px;
}

.page-template >>> .appletTemplateBox {
  background-color: #f2f2f2;
}
.page-template >>> .appletUrgentAuditBox {
  background-color: #f2f2f2;
}

.draftTip {
  height: 30px;
  display: flex;
  flex-flow: row nowrap;
}

.tipText {
  line-height: 28px;
  text-indent: 10px;
  background-color: #f2f2f2;
  width: 100%;
}

.draftTable,.merchantsTable {
  margin-top: 10px;
}

.page-template >>> .tableHeader th .cell {
  /* background-color: red; */
}

.cellOperator{
    display: flex;
    flex-flow:row nowrap ;
    justify-content: space-between;
}

.draftTable>>>.el-table__body-wrapper{
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 178px;
}

.queryMerchants{
  margin-top:10px;
}

.queryUrgent{
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
}
.queryUrgent .urgentPanel{
  width: calc(24% + 12px);
  height: 72px;
  display: inline-block;
  background-color: #ffffff;
}
.queryUrgent .urgentPanel .urgentPanelTitle{
  padding-left: 20px;
  height:50%;

  line-height: 34px;
  font-size: 14px;
  color: #000000;
}
.queryUrgent .urgentPanel .urgentPanelValue{
  padding-left: 20px;
  line-height: 34px;
  font-size: 14px;
  color: #5E57E3;
}
</style>



// WEBPACK FOOTER //
// src/page/system/applet/Setting.vue